import api from './api'

const loadLatestRejectedNfcForUser = (): Promise<string> => api<string>({ path: `/users/nfctags/rejected` })

export default loadLatestRejectedNfcForUser
